// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_kVJ4S","foot_link":"index_foot_link_ckExx","list":"index_list_1KI0I","link":"index_link_0bVtU","copyright":"index_copyright_kBHTp"};